import { formApi } from '@/api/';
export default {
  data () {
    return {
      captchaSerialNum: '',
      captchaText: '',
      serialImg: ''
    }
  },
  activated() {
    setTimeout(() => {
      this.getCaptcha()
    }, 500)
  },
  methods: {
    // 图形码序列号
    async getCaptcha() {
      try {
        let params = {};
        let data = (await formApi.serialNumber(params)).data;
        if (data.statusCode === 200) {
          this.captchaSerialNum = data.data;
          this.graphicCode();
        }
      } catch (err) {
      } finally {
      }
    },
    // 图形码
    async graphicCode() {
      try {
        let params = {
          captchaSerialNum: this.captchaSerialNum
        };
        let data = (await formApi.graphicCode(params)).data;
        let blob = new Blob([data], { type: 'image/*' });
        this.serialImg = URL.createObjectURL(blob);
      } catch (err) {
        console.error(err);
      } finally {
      }
    }
  }
}
